import React, { useRef } from "react";

const HealthBloodForm = ({ onSubmit, onCancel }) => {
    const startDateRef = useRef(new Date().toISOString());
    const endDateRef = useRef(new Date().toISOString());

    return (
        <form
            method="POST"
            onSubmit={e => {
                e.preventDefault();
                onSubmit({
                    start: startDateRef.current.value,
                    end: endDateRef.current.value
                });
            }}
        >
            <div className="form-group">
                <label htmlFor="date-start">Start Date*</label>
                <input type="date" className="form-control input-height" id="date-start" ref={startDateRef} required aria-describedby="date-start" />
            </div>
            <div className="form-group">
                <label htmlFor="date-start">End Date*</label>
                <input type="date" className="form-control input-height" id="date-start" ref={endDateRef} required aria-describedby="date-start" />
            </div>

            <div className="form-group text-center m-t-20">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success">
                    Create
                    <i className="material-icons">keyboard_arrow_down</i>
                </button>
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle">
                    Cancel <i className="material-icons text-danger">close</i>
                </button>
            </div>
        </form>
    );
};
export default HealthBloodForm;
